<template>
  <div>
    <heat-map :lines="lines" v-if="!linesAreLoading" />
    <b-loading :active="linesAreLoading"></b-loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import HeatMap from '@/components/Mood/HeatMap.vue'

export default {
  name: 'Mood',
  props: ['truncated'],
  components: {
    HeatMap
  },
  mounted() {
    if (!this.flattenedLines.length) {
      this.getLines()
    }
  },
  computed: {
    ...mapGetters([
      'flattenedLines',
      'linesAreLoading',
    ]),
    lines() {
      if (this.truncated && this.flattenedLines.length) {
        return [this.flattenedLines[0]]
      }

      return this.flattenedLines
    }
  },
  methods: {
    ...mapActions([
      'getLines'
    ]),
  }
};
</script>

<style scoped lang="scss">

</style>
